export const transpose = (matrix: any) =>
  matrix?.[0]?.map((col: any, i: number) => matrix.map((row: any) => row[i])) ||
  []
